import Api from '../api';
let uri = '/api/ed/renap';

export const getInfoRenap = (data) => {
    return Api.getInstance().executeQuery(`${uri}`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}